import script from "./FastbookingForm.vue?vue&type=script&setup=true&lang=js"
export * from "./FastbookingForm.vue?vue&type=script&setup=true&lang=js"

import "./FastbookingForm.vue?vue&type=style&index=0&id=26021f80&scoped=true&lang=scss"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-26021f80"]])

export default __exports__